import * as React from "react"
import { cn } from "../../lib/cn"

export interface InputProps
    extends React.InputHTMLAttributes<HTMLInputElement> {
    error?: string | boolean
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
    ({ className, type, error, ...props }, ref) => {
        return (
            <div className="w-full relative">
                <input
                    type={type}
                    className={cn(
                        "block w-full min-h-[44px] rounded-md border border-border-default bg-surface-base px-3 py-2 text-base text-left text-text-primary transition-colors duration-150 file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-text-muted focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-inset focus-visible:ring-brand-primary focus-visible:ring-offset-0 focus-visible:border-brand-primary disabled:cursor-not-allowed disabled:opacity-60",
                        error && "border-state-danger",
                        className
                    )}
                    ref={ref}
                    aria-invalid={!!error}
                    {...props}
                />
                {typeof error === "string" && (
                    <p className="mt-1.5 text-xs text-state-danger">{error}</p>
                )}
            </div>
        )
    }
)
Input.displayName = "Input"

export { Input }
